const timeouts = {
    error_message_timeout : 12000,
    success_message_timeout : 12000,
}

export default timeouts;